/* Transom House, First Edition: header state, menu drawer, hotspots, detail rail, reveal on scroll, list form. */
(function () {
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header shadow once the page moves */
  var onScroll = function () { doc.classList.toggle('is-scrolled', window.scrollY > 8); };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* menu drawer */
  var drawer = document.querySelector('[data-drawer]');
  var opener = document.querySelector('[data-menu-open]');
  function closeDrawer(restore) {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    doc.classList.remove('no-scroll');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    if (restore && opener) opener.focus();
  }
  if (drawer && opener) {
    opener.addEventListener('click', function () {
      drawer.hidden = false;
      doc.classList.add('no-scroll');
      opener.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('[data-menu-close]');
      if (first) first.focus();
    });
    drawer.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeDrawer(el.tagName === 'BUTTON'); });
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer(true);
      if (e.key !== 'Tab') return;
      var f = drawer.querySelectorAll('a[href], button');
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) closeDrawer(false); });
  }

  /* shop the look hotspots */
  var spots = document.querySelectorAll('.spot__dot');
  function closeSpots(except) {
    spots.forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var c = document.getElementById(b.getAttribute('aria-controls'));
      if (c) c.hidden = true;
    });
  }
  spots.forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = b.getAttribute('aria-expanded') === 'true';
      closeSpots(b);
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
      var c = document.getElementById(b.getAttribute('aria-controls'));
      if (c) c.hidden = open;
    });
  });
  if (spots.length) {
    document.addEventListener('click', function () { closeSpots(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSpots(null); });
  }

  /* detail rail arrows */
  var rail = document.querySelector('[data-rail]');
  if (rail) {
    var step = function (dir) {
      var item = rail.querySelector('.rail__item');
      var w = item ? item.getBoundingClientRect().width + 24 : 320;
      rail.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
    };
    var prev = document.querySelector('[data-rail-prev]');
    var next = document.querySelector('[data-rail-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  /* reveal on scroll */
  var items = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('in'); });
  }

  /* list form: check the address before it leaves, show a busy state, focus the thank-you */
  document.querySelectorAll('.join__form, .pw__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type="email"]');
      var ok = input && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
      var err = form.querySelector('.join__error[data-client]');
      if (!ok) {
        e.preventDefault();
        if (!err) {
          err = document.createElement('p');
          err.className = 'join__error' + (form.classList.contains('pw__form') ? ' join__error--dark' : '');
          err.setAttribute('role', 'alert');
          err.setAttribute('data-client', '');
          err.id = (input ? input.id : 'join') + '-client-error';
          input.parentNode.insertAdjacentElement('afterend', err);
        }
        err.textContent = 'Please enter a full email address, like name@example.com.';
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', err.id);
        input.focus();
        return;
      }
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
    });
  });
  var done = document.querySelector('[data-join-done]');
  if (done && /customer_posted=true/.test(location.search)) done.focus({ preventScroll: true });
})();
